module.exports = __webpack_public_path__ + "img/home_bg_ecuador.c4a3ead3.jpg";